import { api } from './api';

export type PageViewPayload = {
  fbp: string;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class FacebookCAPI {
  static get BASE_PATH() {
    if (import.meta.client) {
      return [globalThis?.location?.origin || '', 'api/'].join('/');
    }

    return '';
  }

  static async send(payload: PageViewPayload, headers?: Record<string, any>) {
    const response = await api.post(`${FacebookCAPI.BASE_PATH}facebookCapi`, payload, headers);
    return response.data;
  }
}
